import { render, staticRenderFns } from "./service_purchase.vue?vue&type=template&id=55fca440&scoped=true&"
import script from "./service_purchase.vue?vue&type=script&lang=js&"
export * from "./service_purchase.vue?vue&type=script&lang=js&"
import style0 from "./service_purchase.vue?vue&type=style&index=0&id=55fca440&prod&lang=less&"
import style1 from "./service_purchase.vue?vue&type=style&index=1&id=55fca440&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fca440",
  null
  
)

export default component.exports